import { useSubscriptionContext } from '@/context/SubscriptionContext';

import { useIsPremiumFeatureEnabled } from './useIsPremiumFeatureEnabled';
import { useTakenTeamSeats } from './useTakenTeamSeats';

export const SEATS_LIMIT_FOR_NON_PREMIUM = 24;

export const useReachedTeamSeatsLimit = () => {
    const { isPremiumFeatureEnabled } = useIsPremiumFeatureEnabled();
    const { currentOrganisationSubscriptionPlan } = useSubscriptionContext();
    const { takenSeats } = useTakenTeamSeats();

    const seatsLimit = isPremiumFeatureEnabled
        ? currentOrganisationSubscriptionPlan?.seats
        : SEATS_LIMIT_FOR_NON_PREMIUM;

    const hasReachedSeatsLimit = seatsLimit && takenSeats >= seatsLimit;

    return {
        hasReachedSeatsLimit,
        seatsLimit,
        isPremiumEnabled: isPremiumFeatureEnabled,
        takenSeats,
    };
};
